module.exports = __webpack_public_path__ + "img/avatar.0539fe4d.png";